import React from 'react'
import PreviewImage from '../../PreviewImage'
import styles from './CartItem.module.sass'

export default function DisplaySheet({ orderPackage }) {
  const sheet = orderPackage.sheets[0]

  const foreground = (sheet.pose || sheet.seniorImage).imageUrl
  const background = sheet.background && sheet.background.imageUrl

  if (!(foreground && background)) return null

  return (
    <div className={styles.displaySheet}>
      <div>
        <PreviewImage foregroundUrl={foreground} backgroundUrl={background} isPreviewHidden={false} />
      </div>
    </div>
  )
}
